/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_1_TitleInputs */

const en_vc_ft_1_title = /** @type {(inputs: Vc_Ft_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pen and Direct Selection`)
};

const zh_vc_ft_1_title = /** @type {(inputs: Vc_Ft_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`钢笔与直接选择`)
};

/**
* | output |
* | --- |
* | "Pen and Direct Selection" |
*
* @param {Vc_Ft_1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_1_title = /** @type {((inputs?: Vc_Ft_1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_1_title(inputs)
	return zh_vc_ft_1_title(inputs)
});
export { vc_ft_1_title as "vc.ft.1.title" }